'use es6';

export var SET_EMAIL_FORM = 'SET_EMAIL_FORM';
export var RESET_EMAIL_FORM = 'RESET_EMAIL_FORM';
export var SET_FORM_FIELD = 'SET_FORM_FIELD';
export var SET_FORM_STATE = 'SET_FORM_STATE';
export var RESET_FORM_STATE = 'RESET_FORM_STATE';
export var SET_CONSENT_RESPONSES = 'SET_CONSENT_RESPONSES';
export var RESET_CONSENT_RESPONSES = 'RESET_CONSENT_RESPONSES';
export var LOG_ERROR_PAGE_SHOWN = 'LOG_ERROR_PAGE_SHOWN';
export var SHOW_USER_MESSAGE = 'SHOW_USER_MESSAGE';
export var SET_TIMEZONE = 'SET_TIMEZONE';
export var SET_EVENT_DATE = 'SET_EVENT_DATE';
export var SET_EVENT_DATE_TIME = 'SET_EVENT_DATE_TIME';
export var SET_EVENT_DURATION = 'SET_EVENT_DURATION';
export var SET_GIVEN_CONSENT = 'SET_GIVEN_CONSENT';
export var LOG_MEETING_CREATE = 'LOG_MEETING_CREATE';
export var BOOKING_TIME_CONFLICT = 'BOOKING_TIME_CONFLICT';
export var COMPANY_NAME_FETCH_STARTED = 'COMPANY_NAME_FETCH_STARTED';
export var COMPANY_NAME_FETCH_SUCCEEDED = 'COMPANY_NAME_FETCH_SUCCEEDED';
export var COMPANY_NAME_FETCH_FAILED = 'COMPANY_NAME_FETCH_FAILED';
export var MEETINGS_USER_FETCH_STARTED = 'MEETINGS_USER_FETCH_STARTED';
export var MEETINGS_USER_FETCH_SUCCEEDED = 'MEETINGS_USER_FETCH_SUCCEEDED';
export var MEETINGS_USER_FETCH_FAILED = 'MEETINGS_USER_FETCH_FAILED';
export var SET_ACTIVE_LOCALE = 'SET_ACTIVE_LOCALE';
export var SET_ACTIVE_LOCALE_FINISHED = 'SET_ACTIVE_LOCALE_FINISHED';
export var PUBLIC_AVAILABILITY_INFO_FETCH_STARTED = 'PUBLIC_AVAILABILITY_INFO_FETCH_STARTED';
export var PUBLIC_AVAILABILITY_INFO_FETCH_SUCCEEDED = 'PUBLIC_AVAILABILITY_INFO_FETCH_SUCCEEDED';
export var PUBLIC_AVAILABILITY_INFO_FETCH_FAILED = 'PUBLIC_AVAILABILITY_INFO_FETCH_FAILED';
export var PUBLIC_AVAILABILITY_INFO_OWNER_FETCH_STARTED = 'PUBLIC_AVAILABILITY_INFO_OWNER_FETCH_STARTED';
export var PUBLIC_AVAILABILITY_INFO_OWNER_FETCH_SUCCEEDED = 'PUBLIC_AVAILABILITY_INFO_OWNER_FETCH_SUCCEEDED';
export var PUBLIC_AVAILABILITY_INFO_OWNER_FETCH_FAILED = 'PUBLIC_AVAILABILITY_INFO_OWNER_FETCH_FAILED';
export var MEETING_CREATE_STARTED = 'MEETING_CREATE_STARTED';
export var MEETING_CREATE_SUCCEEDED = 'MEETING_CREATE_SUCCEEDED';
export var MEETING_CREATE_RESET = 'MEETING_CREATE_RESET';
export var MEETING_CREATE_FAILED = 'MEETING_CREATE_FAILED';
export var MEETING_CREATE_UNINITIALIZED = 'MEETING_CREATE_UNINITIALIZED';
export var TOGGLE_TROUBLESHOOT_MODE = 'TOGGLE_TROUBLESHOOT_MODE';
export var SET_LEGITIMATE_INTEREST_CONFIRMED = 'SET_LEGITIMATE_INTEREST_CONFIRMED';
export var PORTAL_AUTH_SUCCEEDED = 'PORTAL_AUTH_SUCCEEDED';
export var UPDATE_RECAPTCHA_WIDGET_ID = 'UPDATE_RECAPTCHA_WIDGET_ID';
export var UPDATE_RECAPTCHA_TOKEN = 'UPDATE_RECAPTCHA_TOKEN';
export var FETCH_EVENT_DETAILS_SUCCEEDED = 'FETCH_EVENT_DETAILS_SUCCEEDED';
export var FETCH_EVENT_DETAILS_FAILED = 'FETCH_EVENT_DETAILS_FAILED';
export var MEETING_CANCEL_STARTED = 'MEETING_CANCEL_STARTED';
export var MEETING_CANCEL_SUCCEEDED = 'MEETING_CANCEL_SUCCEEDED';
export var MEETING_CANCEL_FAILED = 'MEETING_CANCEL_FAILED';
export var MEETING_RESCHEDULE_STARTED = 'MEETING_RESCHEDULE_STARTED';
export var MEETING_RESCHEDULE_SUCCEEDED = 'MEETING_RESCHEDULE_SUCCEEDED';
export var MEETING_RESCHEDULE_FAILED = 'MEETING_RESCHEDULE_FAILED';